import { MENUANDPAGES_LOADING, GET_MENUANDPAGES_DATA_SUCCESS, GET_MENUANDPAGES_DATA_ERROR } from "../actions/actionMenuAndPages";
import { put, takeEvery } from 'redux-saga/effects';
import { apiMenusAndPages } from 'api';

async function fetchAsync(func, param) {
  const response = await func(param);

  if (response.ok && response.status == 200) {
    return await response.json();
  }
  else if (response.status == 204) {
    return "nocontent";
  }
  if (response.status == 400) {
    let error = await response.json();
    throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"" + error.Errors[0].ErrorMessage.replace('Error: ', '') + " response status: " + response.status + "\"}]}")
  }
  else {
    throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to get menus and pages, response status: " + response.status + "\"}]}")
  }
}

function* fetchMenuAndPages(action) {
  try {

    const data = yield fetchAsync(apiMenusAndPages, action.applicationId)
    yield put({ type: GET_MENUANDPAGES_DATA_SUCCESS, payload: data });

  } catch (e) {
    yield put({ type: GET_MENUANDPAGES_DATA_ERROR, error: e.Errors[0].ErrorMessage });
  }
}

export const sagaMenuAndPages = [
  takeEvery(MENUANDPAGES_LOADING, fetchMenuAndPages)
];
